/* tslint:disable */

/**
 * grpc/client_data/client-data.service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * What a client\'s time zone was worked out from, most trusted first.   - TIMEZONE_SOURCE_INVALID: The zone is unknown.  - TIMEZONE_SOURCE_CITY: The zone of the client\'s city.  - TIMEZONE_SOURCE_DEVICE: The zone the client\'s own device reported with their latest web form.  - TIMEZONE_SOURCE_COUNTRY: The zone of the client\'s country, which has a single one.  - TIMEZONE_SOURCE_PHONE: The zone of the country of the client\'s phone numbers.
 * @export
 * @enum {string}
 */

export const V1TimezoneSource = {
  Invalid: 'TIMEZONE_SOURCE_INVALID',
  City: 'TIMEZONE_SOURCE_CITY',
  Device: 'TIMEZONE_SOURCE_DEVICE',
  Country: 'TIMEZONE_SOURCE_COUNTRY',
  Phone: 'TIMEZONE_SOURCE_PHONE',
} as const

export type V1TimezoneSource = (typeof V1TimezoneSource)[keyof typeof V1TimezoneSource]
